<template>
  <div class="maintenance__page">
    <div class="maintenance__header">
      <app-logo
        class="logo"
        type="image"
      />

      <language-switcher class="header__language" />
    </div>

    <div class="container">
      <div class="maintenance">
        <section class="maintenance__content">
          <h1 class="maintenance__title">
            {{ t('literal.maintenance') }}
          </h1>

          <p class="maintenance__description">
            {{ t('maintenance.explanation_1') }}
          </p>

          <p class="maintenance__sorry">
            {{ t('maintenance.explanation_2') }}
          </p>
        </section>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from '@/vendors/i18n'

import AppLogo from '&/atoms/AppLogo'
import LanguageSwitcher from '&/atoms/LanguageSwitcher'

const { t } = useI18n()
</script>

<style scoped lang="scss">
.maintenance {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  margin-top: 120px;

  &__page {
    background-color: $white;
    min-height: 100vh;
  }

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 24px;
  }

  &__title {
    font-size: em(28px);
    color: $color--primary;
  }

  &__description {
    font-size: em(28px);
    color: $dg;
  }

  &__sorry {
    color: $dg;
    font-weight: lighter;

    &:before {
      content: '';
      width: 80%;
      height: 1px;
      background: $color--primary;
      display: block;
      margin: 24px 0;
    }
  }
}

:deep() {
  .logo {
    max-width: 170px;
    max-height: 70px;
  }
}
</style>
